<script setup lang="ts">
const { data } = defineProps<{ data: Business, class?: string }>()
const openContactModal = ref(false)
const { isOpenNow } = useBusinessHours(data?.hoursFull)
const { id } = useBusiness(data)
</script>

<template>
  <CollectionCard
    :id="id"
    :data="data"
    :online="isOpenNow"
  >
    <template #image>
      <ImageFull
        v-if="data.id && data.logo && data.collectionId"
        :id="data.id"
        :alt="data.name"
        :src="data.logo"
        :collection-id="data.collectionId"
        class="w-full h-full object-cover"
        loading="lazy"
      />
    </template>
    <template #underimage="{ routeName }">
      <NuxtLink
        class="flex flex-wrap gap-3 hover:text-yellow duration-75 font-normal"
        :to="`${routeName}#map`"
      >
        <UIcon
          name="heroicons:map-pin-16-solid"
          class="inline-block text-lightblue w-6 h-6"
        />
        <p class="inline-flex flex-1 line-clamp-2">
          {{ data.map?.name }}
        </p>
      </NuxtLink>
    </template>
    <template #top="{ routeName }">
      <CollectionBusinessRating
        :rating="data.averageRating ?? 0"
        class="text-yellow ml-auto cursor-pointer"
        @click="navigateTo({ path: routeName, hash: '#reviews' })"
      />
    </template>
    <template #heading>
      {{ data.name }}
    </template>

    <template #default>
      <p data-allow-mismatch>
        {{ data.brief }}
      </p>
    </template>
    <template #buttons="{ routeName }">
      <UButton
        size="xl"
        trailing
        color="yellow"
        @click="openContactModal = true"
      >
        Contact
        <Icon
          name="heroicons:cursor-arrow-ripple-solid"
          class="w-6 h-6  text-lightblue animate-pulse"
        />
      </UButton>
      <UButton
        :to="routeName"
        size="xl"
        trailing
        color="pink"
      >
        View Business
        <Icon
          name="gbf:arrow-right"
          class="w-6 h-6 animate-pulse group-hover:animate-ping-pulse"
        />
      </UButton>
    </template>
  </CollectionCard>
  <CollectionBusinessContactModal
    v-model="openContactModal"
    :data="data"
  />
</template>

<style scoped></style>
